/** A tap on the screen → a tile: the ray meets the planet's sphere, the hit turns into planet-local space. */
import { nearestTile, type Grid } from '@bramvasterd/terrella-rules';
import * as THREE from 'three';

const ray = new THREE.Raycaster();
const point = new THREE.Vector2();
const hit = new THREE.Vector3();
const inverse = new THREE.Quaternion();

/** The tile under screen position (x, y), or -1 when the tap misses the planet. */
export function pickTile(
  camera: THREE.Camera,
  planetQuaternion: THREE.Quaternion,
  shownRadius: number,
  grid: Grid,
  x: number,
  y: number,
  width: number,
  height: number,
): number {
  point.set((x / width) * 2 - 1, -(y / height) * 2 + 1);
  ray.setFromCamera(point, camera);
  const o = ray.ray.origin;
  const d = ray.ray.direction;
  const r = shownRadius + 0.1;
  const b = o.dot(d);
  const c = o.dot(o) - r * r;
  const disc = b * b - c;
  if (disc < 0) return -1;
  hit
    .copy(o)
    .addScaledVector(d, -b - Math.sqrt(disc))
    .normalize();
  inverse.copy(planetQuaternion).invert();
  hit.applyQuaternion(inverse);
  return nearestTile(grid, hit.x, hit.y, hit.z);
}
